import styled from 'styled-components';

export const TableWrap = styled.table`
	border-collapse: collapse;
	table-layout:${(p) => p.layout || 'auto'};
	width: 100%;
	border-spacing: 2px;
	border-radius: 4px;
	border-style: hidden;
	box-shadow: 0 0 0 1px #D8D8D8;
`;

export const TableHead = styled.thead`
position: sticky;
top: 0;
zIndex: 1;`;

export const HeadColumn = styled.th`
	background: ${(p)=>p.background || '#E4E8ED'};
	line-height: 20px;
	min-width: ${(p)=>p.width || '154px'};
	font-size:  ${(p)=>p.fsize || '14px'};
	color:  ${(p)=>p.color || '#374B63'};
	padding: ${(p)=>p.padding || '10px'};
	border: ${(p)=> p.border || '1px solid #fff'};
	border-width: ${(p)=> p.borderWidth || '0 1px 0 0'};
	text-align: ${(p)=> p.txtAlign || 'left'};
	&:first-child {
    border-top-left-radius: ${(p)=>p.bdrRad || '4px'};
	}
	&:last-child {
    border-top-right-radius: ${(p)=>p.bdrRad || '4px'};
	}
`;

export const TableData = styled.td`
	font-size: 14px;
	line-height: 20px;
	min-width: ${(p)=>p.$width || '154px'};
	font-size:  ${(p)=>p.fsize || '14px'};
	color:  ${(p)=>p.color || '#374B63'};
	padding: ${(p)=>p.padding || '10px'};
	border: ${(p)=> p.border || '1px solid #fff'};
	border-width: ${(p)=> p.borderWidth || '0 1px 0 0'};
	text-align: ${(p)=> p.txtAlign || 'left'};
	background: ${(p)=>p.background || 'inherit'};

`;
